import React from 'react';
import { View } from 'react-native';
import RadioButton from '../Buttons/RadioButton';
import { LocStr } from '../../../utils/Utils';
import {
  Free_text, list_options_options, list_options_title, search_from_list,
} from '../../../utils/DictionaryManagementUtils';
import RegularText from '../Text/RegularText';

//= ========================================================================

const RecipientRadioPanel = ({
  key_configuration, language, isSelected, onValueChanged,
}) => {
  const myStyles = {
    container: {
      background: '#f7fafc',
      padding: 15,
      paddingStart: 20,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  };

  return (
    <View style={myStyles.container}>
      <View style={myStyles.row}>
        <RadioButton
          key_configuration={key_configuration}
          text={LocStr(search_from_list, language)}
          isSelected={isSelected}
          onPress={() => {
            onValueChanged(key_configuration, true);
          }}
        />
        <RadioButton
          key_configuration={key_configuration}
          text={LocStr(Free_text, language)}
          isSelected={!isSelected}
          onPress={() => {
            onValueChanged(key_configuration, false);
          }}
        />
      </View>
      {key_configuration === 'search_from_list_bank' && (
        <View>
          <RegularText marginBottom={4} isSemiBold>{list_options_title}</RegularText>
          <RegularText marginBottom={0}>{list_options_options}</RegularText>
        </View>
      )}
    </View>
  );
};
export default RecipientRadioPanel;
